import { XmlHelper } from "@/helpers/Xml";
import { Xml2Json } from "./Xml2JsLib/Xml2Json";
import { saveFile, readUploadedFileAsText } from "@/helpers/FileManipulation";
import XmlComposer from "./XmlComposer";

export default class XmlService {
  public xml2Json = Xml2Json;
  public helper = XmlHelper;
  public xmlPostProcessingFunctions: [] | [Function] = [];
  public xmlElementsToRemoveIfEmpty: [] = [];
  public xmlProcessingService: XmlComposer;

  constructor(defaultXml: string) {
    this.xmlProcessingService = new XmlComposer(defaultXml);
    this.xml2Json.initConfigDefaults({});
  }

  /**
   * EXPORT part
   */
  public exportXml(fileName: string | null = null) {
    if (!fileName) {
      let title = document.querySelector("title");
      if (title) fileName = title.innerText;
      else fileName = "NoFileNameOrTitleSpecified";
    }
    let xmlString = this.xmlProcessingService.getXmlString();
    saveFile(xmlString, fileName);
    return xmlString;
  }

  public exportXmlAsString() {
    let xmlString = this.xmlProcessingService.getXmlString();
    return xmlString;
  }
  /**
   * IMPORT part
   */
  public importXml(file: File, silent: boolean = true) {
    console.log("importXml was called file");
    window.FormEngine.form.reset();
    return readUploadedFileAsText(file).then((xmlString: string | unknown) => {
      if (xmlString) {
        this.xmlProcessingService.setStringToXml(xmlString, silent);
      } else {
        console.log("No xml string provided ", xmlString);
      }
    });
  }
  public importXmlFromString(xmlString: string, silent: boolean = true) {
    if (xmlString) {
      window.FormEngine.form.reset();
      this.xmlProcessingService.setStringToXml(xmlString, silent);
    } else {
      console.log("No xml string present. => ", xmlString);
    }
  }

  public importXmlFromVariable() {}
}
